import React from 'react';
import cn from 'classnames';
import { Layout } from 'antd';
import NavBar from '@components/Navbar';
import styles from './index.module.less';
const { Header, Content } = Layout;

export const NewsLayout = ({ children, className }) => {
  return (
    <Layout className={styles.layout}>
      <Header>
        <NavBar />
      </Header>
      <Content className={cn(styles.content, className)}>
        {children}
      </Content>
    </Layout>
  );
};
